export default __webpack_public_path__ + "39a80a2211c179cce59dca8ca436f5a9.svg";